const ssn = {
    ssn : {
        value: "",
        dbqName: "form1[0].Page_1[0].SSN[0]"
     },
    //  examDate: {
    //     value: "",
    //     dbqName: "Date_of_Examination"
    // },
     docName: {
         value: "",
         dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "form1[0].Page_5[0].SectionXVI-ExaminersCertSign[0].TextField8[5]"
    },
    diagnosisDate : []
}

export default ssn ;